import net from '../../utils/net'

export default {
// 获取维修分类列表
  getMntCategoryList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取分类树
  getMntCategoryTreeData (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取新增序号
  getSerialNumber (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取维修故障分类
  getMntProblemCategorys (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取优先级列表
  getPriorityList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取维修分类供应商
  getVendorList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 新建维修分类
  createMntCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取维修分类详情
  getCategoryInfoDetail (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除维修分类
  deleteCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 更新维修分类
  updateMntCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 批量下架
  disableMntCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 批量上架
  enableMntCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },

  // 获取道具分类树
  getPropCategoryTree (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取道具列表
  getPropCategoryPage (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 创建道具分类
  createPropCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 更新道具分类
  updatePropCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取道具详情
  getPropCategoryDetail (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除道具分类
  deletePropCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 上架道具分类
  enablePropCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 下架道具分类
  disablePropCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取道具新增序号
  getPropSerialNumber (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 导出
  sysdomainExport (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.getBlob(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取维修列表数据
  getMntProblemList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取维修问题序号
  getMntProblemNo (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 创建维修问题
  createMntProblem (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取维修问题详情
  getMntProblemDetail (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除维修问题
  deleteMntProblem (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 更新维修问题
  updateMntProblem (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除维修问题分类
  deleteMntProblemCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 增加维修问题分类
  createMntProblemCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 编辑维修问题分类
  updateMntPromblemCategory (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 下载模板
  downloadTemplate (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.getBlob(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 编辑维修问题分类
  importData (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  }
}
